// extracted by mini-css-extract-plugin
module.exports = {"title":"LoginPageDesktop_title__2umkQ","subtitle":"LoginPageDesktop_subtitle__1dzgO"};